(() => {
  const mq = matchMedia('(min-width: 1100px)');
  function syncFooter(root = document) { root.querySelectorAll('.sbs4-footer-col').forEach(el => { el.open = mq.matches || el.hasAttribute('data-mobile-open'); }); }
  const ratingTarget = document.querySelector('[data-sbs4-rating-value]');
  const reviews = document.getElementById('reviewsio-carousel-widget');
  if (ratingTarget && reviews) {
    const syncRating = () => {
      const match = reviews.textContent.match(/(\d[.,]\d+)\s*average/i);
      if (match) {
        const rating = Number(match[1].replace(',', '.'));
        if (rating >= 0 && rating <= 5) ratingTarget.textContent = `${new Intl.NumberFormat(document.documentElement.lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rating)} / 5 · `;
      }
    };
    new MutationObserver(syncRating).observe(reviews, { childList: true, subtree: true });
    syncRating();
  }
  syncFooter(); mq.addEventListener('change', () => syncFooter());
  document.addEventListener('shopify:section:load', event => syncFooter(event.target));
  document.addEventListener('click', event => {
    const brandLink = event.target.closest('.sbs-menu a[href$="#homepage-brands"]');
    if (!brandLink || !document.getElementById('homepage-brands')) return;
    event.preventDefault();
    const menu = brandLink.closest('main-menu');
    if (menu && typeof menu.close === 'function') menu.close(menu.mainDisclosure, false);
    document.getElementById('homepage-brands').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  document.addEventListener('click', event => { const link = event.target.closest('a[href="#sbs4-all-brands"]'); if (link) { const directory = document.getElementById('sbs4-all-brands'); if (directory) directory.open = true; } });
})();
